import React from "react";

// Section label: royal dash + heavy uppercase text.
// `light` renders the text for use on the navy band.
export default function Label({ children, light = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <span className="w-[22px] h-[3px] bg-royal" aria-hidden="true" />
      <span
        className={`font-hanken font-bold uppercase text-[12px] tracking-[0.13em] ${
          light ? "text-white/80" : "text-navy"
        }`}
      >
        {children}
      </span>
    </span>
  );
}
